// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderRow_root__14ZLQ"};